
import { downloadFile, getFileIconWithSuffix, fileSize, canPreviewFile, wkPreviewFile } from '@/utils';
import { crmFileDeleteAPI } from '@/api/common';

export default {
  name: 'FileCell',
  filters: {
    getFileSize: function getFileSize(size) {
      return fileSize(size);
    }
  },
  props: {
    cellIndex: Number,
    data: Object,
    // 完整数据
    list: Array,
    showFoot: {
      type: Boolean,
      default: true
    },
    cursorPointer: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    module_id: [String, Number]
  },
  data: function data() {
    return {};
  },
  // 附件展示效果
  computed: {
    fileIcon: function fileIcon() {
      var temps = this.data.name ? this.data.name.split('.') : [];
      var ext = '';
      if (temps.length > 0) {
        ext = temps[temps.length - 1];
      } else {
        ext = '';
      }
      return getFileIconWithSuffix(ext);
    },
    previewShow: function previewShow() {
      return this.list;
    }
  },
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    /**
     * 下载
     */
    downloadClick: function downloadClick() {
      downloadFile({ path: this.data.filePath || this.data.url, save_name: this.data.save_name, name: this.data.name });
    },


    /**
     * 附件预览
     */
    previewClick: function previewClick() {
      if (canPreviewFile(this.data.name)) {
        wkPreviewFile(this.data.filePath || this.data.url, this.data.name);
      } else {
        this.$bus.emit('preview-image-bus', {
          index: this.cellIndex || 0,
          data: this.list.map(function (item) {
            return {
              url: item.filePath || item.url || item.file_path,
              name: item.name,
              save_name: item.save_name
            };
          })
        });
      }
    },


    /**
     * 删除
     */
    deleteClick: function deleteClick() {
      var _this = this;

      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        crmFileDeleteAPI({
          id: _this.data.file_id,
          save_name: _this.data.save_name,
          module: 'work_task'
        }).then(function (res) {
          _this.$message.success('操作成功');
          _this.$emit('delete', _this.cellIndex, _this.data);
        }).catch(function () {});
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};